module.exports = __webpack_public_path__ + "img/person.e6cb25d.svg";